import { UserRoles } from './types/roles'

type TestStationRoleRegExpsType = {
  [X in UserRoles]: RegExp
}

const ItRole = 'IT'

export const TestStationRoleRegExps: TestStationRoleRegExpsType = {
  [UserRoles.Admin]: new RegExp(`admin|${ItRole}`, 'i'),
  [UserRoles.Client]: new RegExp(`client|${ItRole}`, 'i'),
  [UserRoles.IT]: new RegExp(`${ItRole}`, 'i'),
  [UserRoles.Default]: new RegExp(`default|${ItRole}`, 'i'),
}
